function getGrupos(selectedSubSectors, catalogGroups) {
  var result = [];

  catalogGroups.forEach((grupo) => {
    if (Object.hasOwn(grupo, "filteredL1")) {
      if (selectedSubSectors.includes(grupo.filteredL1[0].id)) {
        result.push({ key: grupo.id, value: grupo.name });
      }
    } else {
      result.push({ key: grupo.id, value: grupo.name });
    }
  });
  return result;
}

export default getGrupos;
